import { blog_card, blog_page } from "@core/gql-mockups/blogs";
import { category_search_page } from "@core/gql-mockups/categories";

const { minimize_str } = require("@core/helpers/string");

export const GET_BLOG_BY_SLUG =(blog_mockup)=> minimize_str(`
 query ($slug: String, $type:Int) {
    result: getBlogBySlug(slug: $slug, type:$type) ${blog_mockup || blog_page}
  }
`);

export const GET_FAVORITE_BLOGS = ({ blog_card_mockup }) =>
  minimize_str(`
 query ($page: Int, $limit:Int) {
    result: getFavoriteBlogs(page: $page, limit:$limit) {
      paginate {
        total
        pages
      }
      data ${blog_card_mockup || blog_card}
    }
  }
`);

export const GET_BLOGS = ({ blog_card_mockup }) =>
  minimize_str(`
  query(
    $filter: BlogFilter
    $page: Int
    $limit: Int
    $sort: String
  ) {
    result: getBlogs(
      filter: $filter
      page: $page
      limit: $limit
      sort: $sort
    ){
      paginate {
        total
        pages
        page
      }
      data ${blog_card_mockup || blog_card}
    }
  }
`);

export const GET_SEARCH_BLOGS = ({ blog_card_mockup, category_card_mockup }) =>
  minimize_str(`
  query (
    $page: Int,
    $limit: Int,
    $search: String
    ) {
    result: getBlogsSearch(page: $page, limit: $limit, search: $search) {
      blogs ${blog_card_mockup || blog_card}
      categories ${category_card_mockup || category_search_page}
    }
  }
`);
